import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

const NotFound = lazy(() => import("./pages/NotFound"));
const BookingSuccess = lazy(() => import("./pages/BookingSuccess"));
const BookingCanceled = lazy(() => import("./pages/BookingCanceled"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const MedicalDisclaimer = lazy(() => import("./pages/MedicalDisclaimer"));
const BrazilPharmacyGuide = lazy(() => import("./pages/BrazilPharmacyGuide"));
const WhatWeTreat = lazy(() => import("./pages/WhatWeTreat"));
const ConditionPage = lazy(() => import("./pages/ConditionPage"));
const TravelInsurance = lazy(() => import("./pages/TravelInsurance"));
const CityPage = lazy(() => import("./pages/CityPage"));

const queryClient = new QueryClient();

const RouteFallback = () => (
  <div className="min-h-screen bg-background" aria-hidden="true" />
);

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/booking-success" element={<BookingSuccess />} />
              <Route path="/booking-canceled" element={<BookingCanceled />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
              <Route path="/brazil-pharmacy-guide-for-foreigners" element={<BrazilPharmacyGuide />} />
              <Route path="/what-we-treat" element={<WhatWeTreat />} />
              <Route path="/what-we-treat/:slug" element={<ConditionPage />} />
              <Route path="/travel-insurance-reimbursement-brazil" element={<TravelInsurance />} />
              <Route path="/english-speaking-doctor-sao-paulo" element={<CityPage />} />
              <Route path="/english-speaking-doctor-salvador" element={<CityPage />} />
              <Route path="/english-speaking-doctor-florianopolis" element={<CityPage />} />
              <Route path="/english-speaking-doctor-foz-do-iguacu" element={<CityPage />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
